import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCrossCircleBox16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconCrossCircleBox16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3 3h10a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1M1 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm10 4a3 3 0 1 1-6 0 3 3 0 0 1 6 0m1 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0M9.354 6.646a.5.5 0 0 1 0 .708L8.707 8l.647.646a.5.5 0 1 1-.708.708L8 8.707l-.646.647a.5.5 0 1 1-.708-.708L7.293 8l-.647-.646a.5.5 0 1 1 .708-.708L8 7.293l.646-.647a.5.5 0 0 1 .708 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCrossCircleBox16);
